import React, { useCallback, useEffect, useRef, useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import OrderAttachment from './OrderAttachments';
import FileSelector from './FileSelector';
import toastMessageActions from 'jd-library/toastMessageActions';
import { uploadMultipleFiles } from '../RaiseClaimUtills';
import styles from './dispute-images.scss';
import UploadSlider from './UploadSlider';

const getDeviceDataSlice = state => {
	return state.library.deviceData;
};

// let validTypes = ['jpg', 'jpeg', 'png', 'webp','pdf'];
const errorPriority = ['size', 'invalid', 'types', 'maxCount','decodingError'];
let maxSize = 15;
let maxFiles = 9;

const getRandKey = () => Math.floor(Math.random() * Date.now());

const getErrorToShow = (types = [], validTypes = []) => {
	let errorToShow = '';
	const msgMap = {
		maxCount: `Maximum ${maxFiles} Images Can be Uploaded`,
		size: `Please Upload Images less than ${maxSize} MB`,
		types: `Only ${validTypes
			.map(str => str.toUpperCase())
			.join(', ')} Files are Supported`,
		invalid: 'Please Upload a valid file',
		permissions: 'No permissions',
		decodingError:"Uploaded File is corrupted.Please Upload a valid file"
	};

	types.forEach(type => {
		if (errorPriority.indexOf(type) > errorPriority.indexOf(errorToShow)) {
			errorToShow = type;
		}
	});

	return msgMap[errorToShow];
};

const validateFile = (file, validTypes = []) => {
	const fileSizeInMB = file.size / (1024 * 1024);
	const fileType = file.name
		.split('.')
		.pop()
		.toLowerCase();

	if (validTypes.indexOf(fileType) === -1) {
		return {
			success: false,
			errorType: 'types'
		};
	}

	if (fileSizeInMB > maxSize) {
		return {
			success: false,
			errorType: 'size'
		};
	}

	return {
		success: true
	};
};

const generateCode = (storeId, supid) => {
	let randomStr = Math.random()
		.toString(36)
		.replace(/[^a-z]+/g, '')
		.substr(0, 5);
	let sup64 = btoa(supid);
	let stId64 = btoa(storeId);
	let random64 = btoa(randomStr);
	let secData =
		random64 + '#' + sup64 + '#' + stId64 + '#' + sup64 + '#' + random64;
	return btoa(secData);
};

const DisputeImages = props => {
	const deviceData = useSelector(getDeviceDataSlice, shallowEqual);
	const supplierId = useSelector(state => state.session.supplierId);
	const storeId = useSelector(state => state.permissions.storeId);
	const isReadOnly = useSelector(state => state.session.isReadOnly);
	const isMobile = props.ignoreMobilOption? false: deviceData.isMobile;
	const {
		list,
		hasError,
		updateList,
		updateError,
		disputeRaised,
		noImages,
		uploading,
		isPurchaseImage,
		updateUploading,
		swipeableDrawer,
		viewIssue,
		imagesErrMsg,
		disableToast=false,
		usingNewAPI=false,
		brochureAttachment,
		isContractor
	} = props;
	const dispatch = useDispatch();
	const inputRef = useRef(null);
	const secData = useRef(null);
	const [errorMsg, setErrorMsg] = useState('');
	maxFiles = props.maxFiles ? props.maxFiles : maxFiles;
	maxSize = props.maxSize ? props.maxSize : maxSize;

	// const supplierId = Manager ? Manager.CurrentUser.getSupplierId() : '';
	// const storeId = Manager ? Manager.CurrentUser.getStoreId() : '';
	const [showUploadSlider, toggleUploadSlider] = useState(false);

	useEffect(() => {
		secData.current = generateCode(storeId, supplierId);
	}, []);

	const onOptionClick = useCallback((e, option) => {
		toggleUploadSlider(false);
		swipeableDrawer(false);
		switch (option.value) {
			case 'gallery':
				inputRef.current.triggerClick({
					allowMultipleImages: true
				});
				break;
			case 'camera':
				inputRef.current.triggerClick({
					allowMultipleImages: true
				});
				break;
		}
	});
	const tempDelFiles = list ? list.filter(cur => cur.tempDel).length : 0;

	const onFileUpload = useCallback(
		e => {
			let filteredFiles = [];
			const errorList = [];
			const files = e.target.files || [];
			const allowedCount = maxFiles - list.length;
			console.log(typeof files);
			if (files.length > allowedCount) {
				errorList.push('maxCount');
			}
			updateError(false);
			for (let i = 0; i < files.length; i++) {
				const { success, errorType } = validateFile(files[i],props.validTypes);
				if (success) {
					files[i].key = getRandKey();
					filteredFiles.push(files[i]);
				} else {
					errorList.push(errorType);
				}
			}
			if(files.length > allowedCount){
				filteredFiles = filteredFiles.slice(0,allowedCount)
			}

			let imgIndex = -1;
			updateList(list => {
				const newList = [...list];
				filteredFiles.forEach(file => {
					newList.push({
						loading: true,
						key: file.key,
						url: '',
						finalUrl: ''
					});
				});

				imgIndex = list.length;

				return newList;
			});
			updateUploading(true);
			let pendingFilesToUpload = filteredFiles.length;
			const newUploadedFiles = [];
			uploadMultipleFiles({
				files: filteredFiles,
				usingNewAPI,
				cb: (data, id) => {
					if (!data.success) {
						let index = list.findIndex(
							cur => cur.key == data.key
						);
						let msg = ''
						deleteImage(null, index, false);
						if(data.decodingError){
							errorList.push("decodingError");
							msg = getErrorToShow(errorList,props.validTypes)
							setErrorMsg(msg);
							updateError(true,msg);
						}
						if(data.isError && !disableToast) {
							// updateError(true,data.errMsg);
							dispatch(toastMessageActions.showMessage({
								message: errorMsg || msg,
								type: 'error'
							}))
						}
						return {
							success: false
						};
					}
					if (data.uploaded) {
						pendingFilesToUpload--;
						newUploadedFiles.push(data);
					}
					if (!pendingFilesToUpload) {
						updateUploading(false);
					}
					updateList(list => {
						const newList = [...list];

						const updateIndex = newList.findIndex(cur => {
							return data.key === cur.key;
						});

						if (updateIndex != -1) {
							newList[updateIndex] = {
								...newList[updateIndex],
								loading: false,
								finalUrl: data.finalUrl,
								fileId: data.id,
								extension: data.fileType
							};
							if (data.url) {
								newList[updateIndex] = {
									...newList[updateIndex],
									url: data.url
								};
							}
						} else {
							newList.push({
								loading: false,
								finalUrl: data.finalUrl,
								fileId: data.id,
								extension: data.fileType,
								key: getRandKey()
							});
							if (data.url) {
								newList[updateIndex] = {
									...newList[updateIndex],
									url: data.url
								};
							}
						}

						return newList;
					});

					return {
						success: true
					};
				}
			});
			if (errorList.length) {
				if (errorList.indexOf('maxCount') == -1) {
					updateError(true,getErrorToShow(errorList,props.validTypes));
				}
				if(!disableToast){
					dispatch(
						toastMessageActions.showMessage({
							message: getErrorToShow(errorList,props.validTypes),
							type: 'error'
						})
					);
				}
				setErrorMsg(getErrorToShow(errorList,props.validTypes));
			} else {
				updateError(false,getErrorToShow(errorList,props.validTypes));
			}
		},
		[list]
	);

	const deleteImage = (e, index, updateServer = true) => {
		e && e.stopPropagation();
		updateList(list => {
			const newList = [...list];
			newList.splice(index, 1);
			return newList;
		});
	};

	const mobileUpload = () => {
		swipeableDrawer(true);
		toggleUploadSlider(true);
	};

	const OrderAttachments = brochureAttachment ? brochureAttachment : OrderAttachment;
	return (
		<div className={`${styles['dispute-images-return']} ${props.ignoreMobCss?styles['ignore-media']:''}`}>
			<OrderAttachments
				maxFiles={maxFiles}
				list={list}
				editable
				onAdd={mobileUpload}
				popClickOptions={onOptionClick}
				isUploadPrescription
				isMobile={isMobile}
				isError={hasError}
				onCross={deleteImage}
				disputeRaised={disputeRaised}
				viewIssue={viewIssue}
				btnTxt={props.btnTxt}
				customBtn={props.customBtn}
				onDelete={(e, index, id) => props.onDelete({ brochureId: id })}
				from={props.from}
				isContractor={isContractor}
				isReadOnly={isReadOnly}
			/>
			{!disputeRaised ? (
				<FileSelector
					ref={inputRef}
					onChange={props.onFileUpload ? props.onFileUpload : onFileUpload}
					fileType={props.fileType?props.fileType : props.validTypes.map(type => '.' + type).join(', ')}
				/>
			) : null}
			{hasError && !noImages ? (
				<div className={`${styles['dispute-error']}`}>{errorMsg}</div>
			) : hasError && noImages ? (
				<div className={`${styles['dispute-error']}`}>
					{imagesErrMsg
						? imagesErrMsg
						: 'Please Attach the Signed Manifest & Parcel Photos'}
				</div>
			) : null}
			{showUploadSlider && (
				<UploadSlider
					onHidden={() => {
						toggleUploadSlider(false);
						swipeableDrawer(false);
					}}
					showCameraOption={isMobile}
					onOptionClick={onOptionClick}
				/>
			)}
		</div>
	);
};

export default DisputeImages;
